import React from "react";
import bannerBgImage from "../../assets/img/getbg.png";

const Banner = () => {
	return (
		<div
			className='relative text-center px-4 bg-cover bg-center bg-no-repeat lg:pt-40 pt-32 pb-16 bg-fixed'
			style={{ backgroundImage: `url(${bannerBgImage})` }}>
			{/* Overlay */}
			<div className='absolute inset-0 bg-black opacity-50'></div>
			<div className='relative flex flex-col items-center z-10'>
				<h1 className='lg:text-[64px] text-5xl lg:leading-[76px] leading-[60px] font-semibold text-white mb-4'>
					Get Started with Access to Care
				</h1>
				<p className='w-full lg:w-1/2 text-lg text-white mb-8'>
					We remove barriers to healthcare for under-served individuals and
					families. Our goal is to connect you to the healthcare you deserve,
					quickly and efficiently. By simply providing us with your details,
					we’ll ensure you are linked with a trusted healthcare provider.
				</p>
			</div>
		</div>
	);
};

export default Banner;
